export default __webpack_public_path__ + "static/media/user-striped.48f61dff.svg";